import * as React from "react";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { IconDefinition } from "@fortawesome/fontawesome-svg-core";
import { byPrefixAndName } from "@awesome.me/kit-d560caf08c/icons/modules";

import { Copyright } from "../components/content-blocks/copyright";

export const Footer = () => {
  interface AddressProps {
    address?: string[];
    map?: string;
  }
  const Address = ({ address, map }: AddressProps) => (
    <>
      <Row className="footer-row">
        <Col xs={1} className="footer-text mt-1">
          <a href={map} target="_blank" rel="noreferrer">
            <FontAwesomeIcon
              icon={byPrefixAndName.fas["map-location-dot"]}
              className="footer-icon-inflate"
            />
          </a>
        </Col>
        <Col xs={11} className="footer-text">
          <a href={map} target="_blank" rel="noreferrer">
            {address.map((line, idx) => (
              <div
                key={`address-line-${line}`}
                data-testid={`address-line-${idx}`}
              >
                {line}
              </div>
            ))}
          </a>
        </Col>
      </Row>
    </>
  );

  interface LinkProps {
    icon: IconDefinition;
    link: string;
    label: string;
    testId: string;
  }
  const makeLink = ({ icon, link, label, testId }: LinkProps) => (
    <Row className="footer-row">
      <Col xs={12} className="footer-text">
        <a href={link} data-testid={`${testId}-link`}>
          <FontAwesomeIcon icon={icon} className="footer-icon-inflate px-2" />
          {label}
        </a>
      </Col>
    </Row>
  );

  const socialLinks = (alternate = false) => {
    const fbLink = process.env.FB_LINK;
    const instaLink = process.env.INSTA_LINK;

    const links = [
      { name: "FB", link: fbLink, fa: "facebook-square" },
      { name: "Insta", link: instaLink, fa: "instagram-square" },
    ];
    return (
      <div>
        {links.map(({ name, link, fa }) => {
          if (!link) {
            return "";
          }

          return (
            <div key={link}>
              <a
                href={link}
                target="_blank"
                rel="noreferrer"
                className="footer-icon"
              >
                <FontAwesomeIcon
                  icon={byPrefixAndName.fab[fa]}
                  className="footer-icon-inflate"
                />
              </a>
              <a
                href={link}
                className="footer-links"
                target="_blank"
                data-testid={`social-${name}${alternate ? "-alt" : ""}`}
                rel="noreferrer"
              >
                {name}
              </a>
            </div>
          );
        })}
      </div>
    );
  };

  return (
    <div className="footer">
      <div className="footer-layer contrast">
        <div className="constrain-width">
          <Row className="footer-high-row">
            <Col xs={12} md={3}>
              <div className="footer-logo" />
            </Col>
            <Col xs={8} md={4}>
              {makeLink({
                icon: byPrefixAndName.fas.envelope,
                label: "admin@rangitane.org.nz",
                link: "mailto:admin@rangitane.org.nz?subject=Website Enquiry",
                testId: "email",
              })}
              {makeLink({
                icon: byPrefixAndName.fas["phone-office"],
                label: "03 578 6180",
                link: "tel:+6435786180",
                testId: "phone",
              })}
              {makeLink({
                icon: byPrefixAndName.fas.messages,
                label: "Contact Us",
                link: "/contact-us",
                testId: "contact",
              })}
            </Col>
            <Col xs={4} className="d-block d-md-none">
              <div className="footer-social">{socialLinks(true)}</div>
            </Col>
            <Col xs={12} md={3} className="footer-divider-right">
              <Address
                map="https://www.google.com/maps/place/Te+Runanga+a+Rangitane+o+Wairau+Trust/@-41.5140424,173.9545636,664m/data=!3m3!1e3!4b1!5s0x6d39149771fa577b:0x65f4ff5605f27b6e!4m6!3m5!1s0x6d391499bc3cedd9:0xa2d6e90543a71f74!8m2!3d-41.5140464!4d173.9571385!16s%2Fg%2F1ts1mtyv?entry=ttu&g_ep=EgoyMDI1MDQwNi4wIKXMDSoASAFQAw%3D%3D"
                address={[
                  "Level 5, Rangitāne House",
                  "2 Main Street",
                  "PO Box 883",
                  "Blenheim 7240",
                ]}
              />
            </Col>
            <Col sm={2} className="d-none d-md-block">
              <div className="footer-social">{socialLinks()}</div>
            </Col>
          </Row>
          <Row className="footer-high-row">
            <Col xs={12} md={6}>
              <Copyright />
            </Col>
            <Col xs={12} md={6}>
              <p className="copyright-plink">
                <a
                  className="copyright-link"
                  href="https://plink.co.nz"
                  data-testid="creator"
                  target="_blank"
                  rel="noreferrer"
                >
                  Nā Plink Software tēnei
                </a>
              </p>
            </Col>
          </Row>
        </div>
      </div>
    </div>
  );
};
